import React from "react";

import Grid from "@mui/material/Grid2";

// Mui Styles
import { YearPicker } from "@mui/x-date-pickers/YearPicker";
// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import SystemCard from "@/components/systemCard";
import Title from "@/components/title";

// Fetch
import { deleteWorkLocationRecord, getWorkExist } from "@/fetch/fetchWork";

import { numberFormat } from "@/config/normalConfig";
import { getRosterExist } from "@/fetch/fetchRoster";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

const SystemSettingPage = (props) => {
  const { open, setOpen } = props;

  // Navigate
  const navigate = useNavigate();

  const [yearValue, setYearValue] = React.useState(moment());
  const [existData, setExistData] = React.useState({
    work: [],
    roster: [],
  });
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [availableMonth, setAvailableMonth] = React.useState({
    availableMonth: [],
  });

  const handleOnClick = async (month, type) => {
    //To do popup

    const year = moment(yearValue).format("YYYY");
    const datetime = moment(`${year}-${month}-01`).format("YYYY-MM-DD");

    if (type === "work") {
      await deleteWorkLocationRecord(datetime).then((data) => {
        if (data.results) {
          setSnackMessage(`刪除成功`);
        } else {
          setSnackMessage(`刪除失敗`);
        }
        setSnackOpen(true);
        setTimeout(() => {
          setSnackOpen(false);
        }, 1500);
      });
    }

    fetchAll();
  };

  const fetchAll = async () => {
    setExistData({
      work: [],
      gift: [],
      product: [],
      roster: [],
    });

    let workExist,
      giftExist,
      rosterExist,
      productExist = {};
    await getWorkExist(moment(yearValue).format("YYYY")).then((data) => {
      if (data.results) {
        workExist = { work: data.data };
      } else {
        workExist = { work: [] };
      }
    });

    await getRosterExist(moment(yearValue).format("YYYY")).then((data) => {
      if (data.results) {
        rosterExist = { roster: data.data };
      } else {
        rosterExist = { roster: [] };
      }
    });

    setExistData({
      ...existData,
      ...giftExist,
      ...workExist,
      ...productExist,
      ...rosterExist,
    });
  };

  React.useEffect(() => {
    fetchAll();

    /*
      1. api call for retrieve the past 12 months data availabe and pass down to its child component 'systemsettinggiftmenu'for use
      2. it will call api in advance here 
      3. avoid calling api repeatly because looping to generate its child component will happen in this level
    */
    //////////////////////////////////////////////////////////////////////////////////////////////////////////

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [yearValue]);

  return (
    <Layout
      header="StaffManagePage"
      selectedIndex={12}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title="系統設定"
        history={() => navigate(-1)}
        children={
          // <Tabs aria-label="basic tabs example">
          //   <Tab label="Item One" />
          //   <Tab label="Item Two" />
          //   <Tab label="Item Three" />
          //</Tabs>
          <YearPicker
            minDate={moment().subtract(1, "Y")}
            maxDate={moment().add(1, "Y")}
            date={yearValue}
            onChange={(newValue) => {
              setYearValue(newValue);
            }}
          />
        }
        padding={"lr"}
      />
      <Grid container spacing={4}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month, index) => (
          <Grid
            key={index}
            size={{
              xs: 12,
              sm: 6,
              md: 6,
              lg: 3,
            }}
          >
            <SystemCard
              {...availableMonth}
              month={numberFormat(month)}
              year={moment(yearValue).format("YYYY")}
              workExist={existData.work.includes(month)}
              handleOnClick={handleOnClick}
              fetchAll={fetchAll}
              setSnackOpen={setSnackOpen}
              setSnackMessage={setSnackMessage}
            />
          </Grid>
        ))}
      </Grid>
    </Layout>
  );
};

export default SystemSettingPage;
